import React from 'react'

import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Popover from '@material-ui/core/Popover';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import PauseIcon from '@material-ui/icons/Pause';
import PlayIcon from '@material-ui/icons/PlayArrow';
import StopIcon from '@material-ui/icons/Stop';
import ReplayIcon from '@material-ui/icons/Replay';
import Close from '@material-ui/icons/Close';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import Fade from '@material-ui/core/Fade';

import TimeView from "./TimeView";
import { DELAY } from '../../../../Constants';

interface Props {
  status: string;
  sourceSelected: number;
  handlePlayRecord: () => void;
  handlePauseRecord: () => void;
  handleResumeRecord: () => void;
  handleStopRecord: () => void;
  handleCancelSession: () => void;
}

interface State {
  tooglePlayPauseIcon: boolean;
  restartButtonEl: HTMLElement | null;
  time: number;
  formattedTime: string
}

class Controls extends React.Component<Props, State> {

  private timer: any = null;
  private timeoutTimer: any = null;

  constructor(props: Props) {
    super(props);
    this.state = {
        tooglePlayPauseIcon: false,
        restartButtonEl: null,
        time: 0,
        formattedTime: "00:00"
    };
  }  
  
  componentDidUpdate(prevProps: Props) {
    if (prevProps.status !== this.props.status) {
      if(this.props.status === 'recording') {
        this.delayStartTimer()
      } else {
        this.stopTimer()
      }
    }
  }   

  componentWillUnmount(): void {
    clearTimeout(this.timer)
  }  

  handleStop = () => {
    this.props.handleStopRecord();
    this.stopTimer()
  }

  handlePause = () => {
    if (this.props.status === "recording") {
      this.props.handlePauseRecord();
      this.pauseTimer()
      this.setState({
        tooglePlayPauseIcon: true
      });      
    }
  }  

  handlePlay = () => {
    this.props.handlePlayRecord();
    this.stopTimer()
    this.startTimer()
    this.setState({
      tooglePlayPauseIcon: false,
      restartButtonEl: null
    }); 
  }
  
  handleResume = () => {
    this.props.handleResumeRecord();
    this.startTimer()
    this.setState({
      tooglePlayPauseIcon: false
    });      
  } 

  handleCancelSession = () => {
    this.props.handleCancelSession();    
    this.props.handleStopRecord();
    this.setState({
      restartButtonEl: null
    });
  }  

  handleClickRestartIcon = (event: any) => {
    this.setState({
      restartButtonEl: event.currentTarget
    });
  }  

  handleCloseRestartPopover = () => {
    this.setState({
      restartButtonEl: null
    });
  }  

  delayStartTimer = () => {
    clearTimeout(this.timeoutTimer)
    this.timeoutTimer = setTimeout(() => {
      this.startTimer()
    }, DELAY);
  }

  startTimer = () => {
    this.timer = setInterval(() => {
      this.setState({
        time: this.state.time + 1,
        formattedTime: this.formatTime(this.state.time + 1)
      });
    }, 1000);
  }  

  pauseTimer = () => {
    clearInterval(this.timer);
  }
  
  stopTimer = () => {
    clearInterval(this.timer);
    this.setState({
      time: 0,
      formattedTime: "00:00"
    });
  }  

  formatTime = (secs: number) => {
    let date = new Date(0);
    date.setSeconds(secs);
    let formattedTime = date.toISOString().substr(14, 5);

    return formattedTime;
  }  
  
  renderRestartPopover() {
    const { restartButtonEl } = this.state;
    
    return (
      <Popover
        id="restart-popover"
        open={Boolean(restartButtonEl)}
        anchorEl={restartButtonEl}
        onClose={this.handleCloseRestartPopover}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        <Box p='8px 16px 16px'>
          <Box textAlign="right">
            <IconButton
              onClick={this.handleCloseRestartPopover}
              size="small"
            >
              <Close />
            </IconButton>
          </Box>
          <Box p={1}>
            <Typography color="textSecondary" gutterBottom>
              Restart current recording?
            </Typography>
          </Box>
            <Button
              color="inherit"
              onClick={this.handleCancelSession}
            >
              Cancel Session
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={this.handlePlay}
            >
              Restart
            </Button>
        </Box>
      </Popover>
    );
  }  

  render() {
    if(
      this.props.status !== 'idle' && 
      this.props.status !== 'acquiring_media' && 
      this.props.status !== 'stopped') {
    return (  
      <Fade in={true} timeout={DELAY * 1.5}>
        <Box
          position='relative'
          width='100%'
          height='100%'
        >
          <Box
            position='fixed'
            zIndex={1}
            right={10}
            bottom={'44%'}
          >
            <Paper elevation={3}>
              <Grid container 
                direction="row"
                justify="center"
                alignItems="center"
                spacing={0}
              >
                { !this.state.tooglePlayPauseIcon ? (
                  <Grid item xs>
                    <IconButton 
                      onClick={this.handlePause} 
                      aria-label="pause" 
                      size="medium"
                    >
                      <PauseIcon fontSize="inherit" />
                    </IconButton>
                  </Grid>
                  ) : (
                  <Grid item xs>
                    <IconButton onClick={this.handleResume} aria-label="resume" size="medium">
                      <PlayIcon fontSize="inherit" />
                    </IconButton>
                  </Grid>
                  )
                }
                <Grid item xs>
                  <IconButton 
                    onClick={this.handleStop}
                    aria-label="stop" 
                    size="medium"
                  >
                    <StopIcon fontSize="inherit" />
                  </IconButton>
                </Grid>
                <Grid item xs>
                  <FiberManualRecordIcon color="error" />
                </Grid>
                <Grid item xs>
                  <TimeView time={this.state.formattedTime} />
                </Grid>
                <Grid item xs>
                  <IconButton 
                    onClick={this.handleClickRestartIcon}
                    aria-label="resume" 
                    size="medium">
                    <ReplayIcon fontSize="inherit" />
                  </IconButton>
                  {this.renderRestartPopover()}
                </Grid>                
              </Grid>
            </Paper>
          </Box>
        </Box>
        </Fade>
    );}
    else {
      return <span />
    } 
  }

  }

export default Controls;  